import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";

const list = [
  {
    pagePath: "/",
    iconPath: "/image/home.png",
    selectedIconPath: "/image/home_on.png",
    text: "首页",
  },
  {
    pagePath: "/shop",
    iconPath: "/image/shop.png",
    selectedIconPath: "/image/shop_on.png",
    text: "首页",
  },
  {
    pagePath: "/bag",
    iconPath: "/image/bag.png",
    selectedIconPath: "/image/bag_on.png",
    text: "首页",
  },
];
export default function Tabbar() {
  const navigate = useNavigate();
  const href = useLocation();
  const [selectUrl, setSelectUrl] = useState("");
  useEffect(() => {
    if (href.pathname) {
      setSelectUrl(href.pathname);
    }
  }, [href]);
  return (
    <Wrapper>
      {list.map((e, i) => (
        <TabberItem
          key={i}
          onClick={() => {
            setSelectUrl(e.pagePath);
            navigate(e.pagePath);
          }}
        >
          {e.pagePath === selectUrl ? (
            <img key={e.pagePath +'_on'} src={e.selectedIconPath} alt="on" />
          ) : (
            <img key={e.pagePath } src={e.iconPath} alt="default" />
          )}
        </TabberItem>
      ))}
      <Bg />
      <BgBlack />
    </Wrapper>
  );
}
const Wrapper = styled.div`
  position: fixed;
  bottom: 2.0rem;
  left: 50%;
  transform: translateX(-50%);
  right: 0;
  width: 25.0rem;
  display: flex;
  align-items: center;
  justify-content: space-around;
  z-index: 999;
`;

const TabberItem = styled.div`
  position: relative;
  z-index: 10;
  padding-top: .5rem;
  img {
    width: 2.7rem;
  }
`;
const Bg = styled.div`
  position: absolute;
  z-index: 9;
  top: -3px;
  left: 0;
  right: 0;
  bottom: 0;
  background: #ffffff;
  border-radius: .7rem;
  transform-origin: bottom;
  transform: perspective(10.0rem) rotateX(14deg);
  box-shadow: 1px 1px 1.4rem -4px #c9c3c3;
`;

const BgBlack = styled.div`
  position: absolute;
  background: #000000;
  border-radius: 2.1rem;
  bottom: -2px;
  left: 2%;
  right: 2%;
  height: 1.1rem;
  z-index: 1;
`;
